<template>
  <div class="home-view container" role="main">
    <Breadcrumbs></Breadcrumbs>
    <Wizzard current-page="voucher"></Wizzard>
    <h1 class="d-flex">Emissão de Certificado</h1>
    <span class="span-tip d-flex mb-3">
      Para emitir um Certificado a partir de um Bird ID, será necessário digitar
      o código do Voucher do Certificado adquirido.
    </span>
    <div class="d-flex row col-12 me-0 ms-0" @keydown.enter="handleSave">
      <div class="col-12 col-md-6 input-voucher-column">
        <span class="d-flex">Nº Voucher/Pedido*</span>
        <Input
          v-model="voucher"
          class="input-voucher mt-2 w-100"
          icon="tag"
          placeholder="Digite o código do Voucher/Pedido"
          :error-log="error"
        />
        <div class="d-flex flex-row justify-content-end">
          <button
            class="btn-next-page btn btn-primary d-flex justify-content-around mt-2 align-self-end"
            type="button"
            :class="[!isValid ? 'btn-secondary' : 'btn-primary']"
            :disabled="!isValid"
            @click="handleSave"
          >
            <div
              class="d-flex flex-row justify-content-center align-items-center gap-2"
            >
              <span>Avançar</span>
              <Icon name="arrow-right"></Icon>
            </div>
          </button>
        </div>
      </div>
      <div class="col-12 col-md-6 accordion-voucher-column pb-md-5z">
        <div id="AccordionWhatsVoucher" class="accordion">
          <div class="accordion-item">
            <div id="AccordionQuestionVoucher" class="accordion-header">
              <button
                class="accordion-button collapsed"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#AccordionAnswerVoucher"
                aria-controls="AccordionAnswerVoucher"
              >
                O que é um Voucher?
              </button>
            </div>
            <div
              id="AccordionAnswerVoucher"
              class="accordion-collapse collapse"
              aria-labelledby="AccordionQuestionVoucher"
              data-bs-parent="#AccordionWhatsVoucher"
            >
              <div class="accordion-body">
                <p class="m-0 text-start">
                  O voucher é um código que você recebe de uma empresa
                  <br />para emitir seu Certificado <br />Digital, como por
                  exemplo, seu contador ou a empresa onde você trabalha. O
                  voucher <br />tem 12 caracteres e é um misto de números e
                  letras. Ex: 001c70fxxxxx.
                </p>
              </div>
            </div>
          </div>
          <div class="accordion-item">
            <div
              id="AccordionQuestionWhereRequestNumber"
              class="accordion-header"
            >
              <button
                class="accordion-button collapsed"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#AccordionAnswerWhereRequestNumber"
                aria-expanded="false"
                aria-controls="AccordionAnswerWhereRequestNumber"
              >
                Onde encontro o número do Pedido?
              </button>
            </div>
            <div
              id="AccordionAnswerWhereRequestNumber"
              class="accordion-collapse collapse"
              aria-labelledby="AccordionQuestionWhereRequestNumber"
              data-bs-parent="#AccordionWhatsVoucher"
            >
              <div class="accordion-body">
                <p class="m-0 text-start">
                  O número do pedido é um número que você recebe assim <br />que
                  efetua uma compra em <br />nosso e-commerce. Este número vai
                  por e-mail junto com as informações de compra <br />e
                  geralmente está contido também no assunto do e-mail.
                </p>
              </div>
            </div>
          </div>
          <div class="accordion-item">
            <div id="AccordionQuestionDontHaveVoucher" class="accordion-header">
              <button
                class="accordion-button collapsed"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#AccordionAnswerDontHaveVoucher"
                aria-expanded="false"
                aria-controls="AccordionAnswerDontHaveVoucher"
              >
                Não tenho um Voucher Nº do Pedido, e agora?
              </button>
            </div>
            <div
              id="AccordionAnswerDontHaveVoucher"
              class="accordion-collapse collapse"
              aria-labelledby="AccordionQuestionDontHaveVoucher"
              data-bs-parent="#AccordionWhatsVoucher"
            >
              <div class="accordion-body">
                <p class="m-0 text-start">
                  Ainda não tem um voucher ou um número de pedido?
                </p>
                <p class="m-0 text-start">
                  Entre em contato conosco e adquira!
                </p>
                <p class="m-0 text-start">{{ arData.foneAR }}</p>
                <p class="m-0 text-start">
                  {{
                    arData.siteAR
                      .replace('https://', '')
                      .replace('http:/', '')
                      .replace('/', '')
                  }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <ModalRFB
      ref="modalRfbRef"
      :create-solicitation="createSolicitation"
      :request="model"
    />
    <ModalRFBError ref="modalRfbRefError" />
  </div>
</template>

<script lang="ts">
  import { defineComponent } from 'vue'

  import loginController, {
    ResponseGetProductsByVoucher,
    VoucherParam,
  } from '@/infra/BirdId/controllers/login.controller'
  import { mapActions, mapState } from 'pinia'
  import { useMainStore } from '@/store/Pinia/useMain.store'
  import { useSolicitation } from '@/store/Pinia/useSolicitation.store'
  import { useAR } from '@/store/Pinia/useAR.store'
  import { useModalLoading } from '@/store/Pinia/useModalLoading.store'
  import { useDynamicForms } from '@/store/Pinia/useDynamicForms.store'
  import { useRouteBirdId } from '@/store/Pinia/useRouteBirdId.store'
  import saveDataVoucher from '@/utils/saveDataVoucher'
  import ModalRFB from '@/components/templates/ModalRFB.vue'
  import ModalRFBError from '@/components/templates/ModalRFBError.vue'
  import { useOeRecaptcha } from '@/utils/useOeRecaptcha'

  export default defineComponent({
    name: 'VoucherView',
    components: {
      ModalRFB,
      ModalRFBError,
    },
    setup() {
      return {
        oeRecaptcha: useOeRecaptcha(),
      }
    },
    data: () => ({
      voucher: '',
      error: '',
      model: {
        token: {
          sessionData: '',
          sessionId: '',
        },
        arsubdomain: '',
        voucher: '',
        cnpj: '',
        produtos: [],
        hasRfb: false,
      } as VoucherParam,
    }),
    watch: {
      voucher(curr) {
        if (curr.length > 0 && this.error) {
          this.error = ''
        }
      },
    },
    errorReq: '',
    computed: {
      ...mapState(useMainStore, ['unidade']),
      ...mapState(useSolicitation, ['getCessToken']),
      ...mapState(useAR, ['arData']),
      isValid() {
        return !!this.voucher && !this.error
      },
    },
    methods: {
      ...mapActions(useDynamicForms, ['setMunicipios', 'setFormData']),
      ...mapActions(useSolicitation, ['saveDataSolicitation', 'setIsRFB']),
      ...mapActions(useModalLoading, ['setIsLoading']),
      ...mapActions(useRouteBirdId, ['setRouterDone']),
      validateHasProductRFB(responseRFB: ResponseGetProductsByVoucher) {
        return responseRFB.consultarCnpjRfbOuQsa
      },
      async handleSave() {
        try {
          this.setIsLoading({
            isLoading: true,
            title: 'Aguarde enquanto localizamos seu Voucher/Pedido',
            image: 'zoom',
            message: '',
          })

          const recaptchaToken = await this.oeRecaptcha.getToken('getproduct')

          this.model = {
            token: this.getCessToken,
            arsubdomain: this.arData.subdomain || '',
            voucher: this.voucher,
          }

          if (this.unidade) {
            this.model.unidade = this.unidade
          }

          const responseRFB = await loginController.getProductsByVoucher({
            arsubdomain: this.arData.subdomain || '',
            cessToken: this.getCessToken,
            voucher: this.voucher,
            recaptcha_token: recaptchaToken,
          })

          const hasProductRFB = this.validateHasProductRFB(responseRFB)
          this.setIsRFB(hasProductRFB || false)

          if (hasProductRFB) {
            this.model = {
              ...this.model,
              produtos: responseRFB.produtos || [],
              hasRfb: hasProductRFB,
            }
            const modal = this.$refs.modalRfbRef as typeof ModalRFB
            modal.modalOpen()
            setTimeout(() => {
              this.setIsLoading({ isLoading: false })
            }, 100)
            return
          }

          await this.createSolicitation(this.model)
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error: any) {
          if (
            error.response &&
            error.response?.data?.message === 'Voucher já utilizado'
          ) {
            this.error = 'Voucher utilizado em outro Certificado'
          } else {
            this.error =
              error.response?.data?.message || 'Voucher ou Pedido inválido.'
          }
        } finally {
          setTimeout(() => {
            this.setIsLoading({ isLoading: false })
          }, 1500)
        }
      },
      async createSolicitation(request: VoucherParam) {
        try {
          const modal = this.$refs.modalRfbRef as typeof ModalRFB
          modal.modalClose()
          const arStore = useAR()

          const recaptchaToken = await this.oeRecaptcha.getToken('login')

          const { data } = await loginController.validateVoucher({
            ...request,
            sub: arStore.getSub,
            recaptcha_token: recaptchaToken,
          })

          const payload = {
            ...data,
            voucher: this.voucher,
          }

          saveDataVoucher(payload)
          this.$router.push('/birdId/form')
        } catch (error: any) {
          if (
            error.response &&
            error.response?.data?.message === 'Consulta RFB falhou'
          ) {
            this.error = 'Consulta RFB falhou'
            this.openModalRFBError()
            return
          }
          if (
            error.response &&
            error.response?.data?.message === 'Voucher já utilizado'
          ) {
            this.error = 'Voucher utilizado em outro Certificado'
            return
          }
          this.error = 'Voucher ou Pedido inválido.'
        } finally {
          setTimeout(() => {
            this.setIsLoading({ isLoading: false })
          }, 1500)
        }
      },
      openModalRFB() {
        const modal = this.$refs.modalRfbRef as typeof ModalRFB
        modal.modalOpen()
      },
      openModalRFBError() {
        const modalerror = this.$refs.modalRfbRefError as typeof ModalRFBError
        modalerror.modalOpen()
      },
    },
    beforeRouteEnter(to, from, next) {
      const solicitation = useSolicitation()
      if (
        !solicitation.getCessToken.sessionData &&
        solicitation.getCessToken.sessionId
      ) {
        return next({ path: '/' })
      }

      return next()
    },
    beforeRouteLeave() {
      this.oeRecaptcha.hideBadge()
    },
    mounted() {
      this.oeRecaptcha.showBadge()
    },
  })
</script>

<style lang="stylus" scoped>
  @import './style.modules.styl';
</style>
